import type { ChatMode } from "@/src/store/types";

export const AGENT_CHAT_MODE: Exclude<ChatMode, "qa"> = "agent-performance";
